module.exports = __webpack_public_path__ + "static/media/logo_homepage.d9a7719e.png";